import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Section from '../components/Section';
import Eyebrow from '../components/Eyebrow';
import cssUrl from '../components/cssUrl';

/** トップページの施工事例セクション（墨背景）。事例一覧ページのグリッドとは別物。 */
export default function WorksSection({ cards, moreHref = '/case', moreLabel = '事例一覧へ →' }) {
  return (
    <Section bg="sumi">
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'flex-end' },
          justifyContent: 'space-between',
          gap: { xs: 2.5, sm: 0 },
          mb: { xs: 5, sm: 8 },
        }}
      >
        <Box>
          <Eyebrow>Works</Eyebrow>
          <Typography variant="h2" component="h2" sx={{ color: 'inherit' }}>
            施工事例
          </Typography>
        </Box>
        <Box
          component="a"
          href={moreHref}
          sx={{
            color: 'rgba(255,255,255,.8)',
            fontSize: 14,
            letterSpacing: '.1em',
            textDecoration: 'none',
            borderBottom: '1px solid rgba(255,255,255,.4)',
            pb: 0.5,
            transition: 'color .25s',
            '&:hover': { color: '#ffffff' },
          }}
        >
          {moreLabel}
        </Box>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: `repeat(${Math.min(cards.length, 3)}, 1fr)` },
          gap: { xs: 6, sm: 4, md: 5 },
        }}
      >
        {cards.map((card) => (
          <Box
            key={card.title}
            component="a"
            href={card.url}
            sx={{ display: 'block', color: '#ffffff', textDecoration: 'none' }}
          >
            <Box sx={{ aspectRatio: '16 / 10', overflow: 'hidden' }}>
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  backgroundImage: cssUrl(card.img_path),
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  transition: 'transform .5s ease',
                  'a:hover &': { transform: 'scale(1.05)' },
                }}
              />
            </Box>
            <Typography variant="h3" component="h3" sx={{ color: 'inherit', fontSize: 20, letterSpacing: '.12em', mt: 3, mb: 1 }}>
              {card.title}
            </Typography>
            <Typography sx={{ fontSize: 14, color: 'rgba(255,255,255,.65)' }}>{card.message}</Typography>
          </Box>
        ))}
      </Box>
    </Section>
  );
}
